import React, { useEffect, useState, useContext } from "react";
import ToggleButton from "../../../common/ToggleButton";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import {
  fetchProviderStatus,
  updateProviderStatus,
  providerDuplicateCheck,
} from "../../../store/Status/ProviderStatusActions";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { MyAccountContext } from "../../../App";
import rolesImage from "../../../assets/images/rolesImage.svg";
import "./providerstatus.scss";
import { formatDateUnrelatedTimezone } from "../../../utils/commonUtilities";

const ProviderStatus = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [resetCount, setResetCount] = useState(false);
  const [toggleKey, setToggleKey] = useState(0);
  const [statusDropdown, setStatusDropdown] = useState("");
  const [enableSaveBtn, setEnableSaveBtn] = useState(false);
  const [reasonSelected, setReasonSelected] = useState(null);
  const [note, setNote] = useState(null);
  const [duplicateProviderId, setDuplicateProviderId] = useState("");
  const [isDuplicateValid, setIsDuplicateValid] = useState(true);
  const [statusUpdate, setStatusUpdate] = useState();
  const [showError, setShowError] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const { grantedRoles = [] } = useContext(MyAccountContext) || {};
  const isManager = grantedRoles.includes("ROLE_MANAGER");
  const isPractice = grantedRoles.includes("ROLE_PRACTICE");

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const providerId = locationHeaderData[2];
  const windowUrl = window.location.href;
  const practiceOrProvider = windowUrl.includes("practice")
    ? "practice"
    : "provider";

  const dispatch = useDispatch();

  const { providerStatusData, providerStatusErrorMsg } = useSelector(
    (state) => state.providerStatus,
  );
  const { providerStatusUpdateErrorMsg } = useSelector(
    (state) => state.providerStatusUpdate,
  );

  useEffect(() => {
    dispatch(fetchProviderStatus(providerId));
  }, []);

  useEffect(() => {
    if (providerStatusData.length > 0) {
      setStatusUpdate(providerStatusData[0]);
      setToggleKey((prev) => prev + 1);
      const newStatus = providerStatusData[0]?.isActive ? "OFF" : "ON";
      console.log("Setting statusDropdown to:", newStatus);
      setStatusDropdown(!providerStatusData[0]?.isActive ? "ON" : "OFF");
    }
  }, [providerStatusData]);

  useEffect(() => {
    console.log({ statusDropdown });
  }, [statusDropdown]);

  useEffect(() => {
    if (reasonSelected && note) {
      if (reasonSelected === "Duplicate") {
        const isValidDuplicateId = /^[A-Za-z0-9]{16}$/.test(
          duplicateProviderId,
        );
        setEnableSaveBtn(isValidDuplicateId && isDuplicateValid);
      } else {
        setEnableSaveBtn(true);
      }
      setShowValidationErrors(false);
    } else {
      setEnableSaveBtn(false);
    }
  }, [reasonSelected, note, duplicateProviderId, isDuplicateValid]);

  useEffect(() => {
    if (openPopup) {
      setShowValidationErrors(true);
    }
  }, [openPopup]);

  useEffect(() => {
    if (providerStatusErrorMsg || providerStatusUpdateErrorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [providerStatusErrorMsg, providerStatusUpdateErrorMsg]);

  const offStatusDropdown = [
    {
      name: "Duplicate",
      value: "Duplicate",
    },
    {
      name: "No License/NPI",
      value: "No License/NPI",
    },
    {
      name: "Suppress - Provider Request",
      value: "Suppress - Provider Request",
    },
    {
      name: "Suppress - Provider Public Incident",
      value: "Suppress - Provider Public Incident",
    },
    {
      name: "Retired/Deceased",
      value: "Retired/Deceased",
    },
  ];

  const onStatusDropDown = [
    {
      name: "Verified",
      value: "Verified",
    },
  ];

  const formStatusSchema = [
    {
      component: "dropdown",
      name: "status",
      dropdownOptions: [
        {
          name: "ON",
          value: "ON",
        },
        {
          name: "OFF",
          value: "OFF",
        },
      ],
      required: true,
      onSelectCallBack: (name, value) => {
        setStatusDropdown(value);
      },
      // defaultValue: statusUpdate?.isActive ? "ON" : "OFF",
      defaultValue: statusDropdown,
    },
    {
      component: "dropdown",
      name: "reason",
      required: true,
      dropdownOptions:
        statusDropdown === "OFF" ? offStatusDropdown : onStatusDropDown,
      dropdownPlaceHolder: "Select a Reason",
      renderCustomError: showValidationErrors && !reasonSelected,
      onSelectCallBack: (name, value) => {
        setReasonSelected(value);
      },
    },
    ...(reasonSelected === "Duplicate"
      ? [
          {
            component: "input",
            label: "DUPLICATE OF PROVIDER ID",
            name: "duplicateProviderId",
            type: "text",
            placeholder: "",
            required: false,
            className: "duplicate-field-inline",
            inputProps: {
              pattern: "^[A-Za-z0-9]{16}$",
            },
            renderCustomError: !isDuplicateValid,
            onKeyChangeCallback: (name, value) => {
              setDuplicateProviderId(value);
              if (value.length === 16 && /^[A-Za-z0-9]{16}$/.test(value)) {
                dispatch(providerDuplicateCheck(value)).then((response) => {
                  const isSuccess = response.payload.success;
                  const hasItems =
                    response.payload.data?.data?.providerResponseDTO?.items
                      ?.length > 0;
                  if (isSuccess && hasItems) {
                    setIsDuplicateValid(true);
                  } else {
                    setIsDuplicateValid(false);
                  }
                });
              } else if (value.length < 16) {
                setIsDuplicateValid(true);
              }
            },
            valueChangeCallback: () => {},
          },
        ]
      : []),
    {
      component: "textarea",
      name: "note",
      label: "Note:",
      cols: 83,
      rows: 10,
      needBorder: true,
      required: true,
      renderCustomError: showValidationErrors && !note,
      onChangeCallback: (res) => {
        console.log(res);
      },
      onKeyChangeCallback: (res) => {
        console.log(res);
        setNote(res);
      },
    },
  ];

  const RenderProviderStatus = () => {
    return (
      <div>
        <div className="statusHeader"> YOUR STATUS </div>
        <div className="locationPopupDescWrapper">
          <div className="locationPopupDesc"></div>
          <div className="locationPopupDesc"></div>
        </div>
        <div
          className={`statusWrapper ${
            reasonSelected === "Duplicate" ? "duplicate-field-active" : ""
          }`}
        >
          <CgFormCreator
            key={resetCount}
            enablePrimaryBtn={enableSaveBtn}
            schema={formStatusSchema}
            onSubmitCallback={(val) => {
              const payload = {
                reasonCode: val.reason,
                note: val.note,
              };
              if (reasonSelected === "Duplicate" && duplicateProviderId) {
                payload.duplicateOfEntityId = duplicateProviderId;
              }
              dispatch(
                updateProviderStatus({
                  providerId: providerId,
                  data: payload,
                }),
              ).then(() => {
                dispatch(fetchProviderStatus(providerId));
                setToggleKey((prev) => prev + 1);
              });
              setOpenPopup(!openPopup);
              setEnableSaveBtn(false);
            }}
            onCancel={() => {
              setResetCount(!resetCount);
              setOpenPopup(!openPopup);
              setEnableSaveBtn(false);
            }}
          />
        </div>
      </div>
    );
  };

  const RenderPopup = () => {
    if (!openPopup) {
      return null;
    }

    return (
      <div className="provider-status-popup">
        <PopupModal
          isOpen={openPopup}
          onClose={() => {
            setOpenPopup(!openPopup);
            setReasonSelected(null);
            setNote(null);
            setDuplicateProviderId("");
            setIsDuplicateValid(true);
            setStatusDropdown(!statusUpdate?.isActive ? "ON" : "OFF");
            setShowValidationErrors(false);
            setResetCount(!resetCount);
            setEnableSaveBtn(false);
          }}
          width="50%"
          customRender={RenderProviderStatus}
        />
      </div>
    );
  };

  const RenderProviderStatusError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {providerStatusErrorMsg || providerStatusUpdateErrorMsg}
      </div>
    );
  };

  return (
    <>
      <div>
        {statusUpdate &&
          (isManager || isPractice ? (
            <div className="toggle-container" key={toggleKey}>
              <span className="toggleLabel">STATUS: </span>
              <span>{statusUpdate?.isActive ? "ON" : "OFF"}</span>
              {(!statusUpdate?.isActive || !statusUpdate?.isDisplayOnsite) && (
                <div className="tooltip-container">
                  <img
                    src={rolesImage}
                    alt="Manager Role"
                    className="tooltip-icon"
                    onClick={() => setShowTooltip(!showTooltip)}
                  />
                  {showTooltip ? (
                    <div className="practice-popover-contect ">
                      <div className="arrow"></div>
                      <div className={"tooltip-content show"}>
                        <h4 className="popup-header">
                          {statusUpdate?.isActive === true &&
                          statusUpdate?.isDisplayOnsite === false
                            ? "ACTIVE - NOT DISPLAYED ON SITE"
                            : "INACTIVE "}
                          <span>
                            {statusUpdate?.isDisplayedOnSite === "false"
                              ? " - Not Displayed On Site"
                              : ""}
                            : {statusUpdate?.reason || statusUpdate?.reasonCode}
                          </span>
                          <span>
                            {statusUpdate?.duplicateOfEntityId === undefined ||
                            statusUpdate?.duplicateOfEntityId === null ||
                            statusUpdate?.duplicateOfEntityId === "" ? null : (
                              <Link
                                to={`/${practiceOrProvider}/${statusUpdate?.duplicateOfEntityId}/profile-information/info`}
                                className="duplicate-link"
                              >
                                ({statusUpdate?.duplicateOfEntityId})
                              </Link>
                            )}
                          </span>
                        </h4>
                        <p className="popup-notes">{statusUpdate?.note}</p>
                        <p className="popup-footer">
                          updated{" "}
                          {formatDateUnrelatedTimezone(
                            statusUpdate?.date?.split("T")[0],
                          )}{" "}
                          by {statusUpdate?.username}
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          ) : (
            <ToggleButton
              key={toggleKey}
              customToggleStyle
              statusUpdate={statusUpdate}
              defaultValue={
                statusUpdate?.isDisplayOnsite && statusUpdate?.isActive
                  ? true
                  : false
              }
              onChangeCallback={() => {
                setOpenPopup(!openPopup);
              }}
            />
          ))}
      </div>
      {!isManager && !isPractice && RenderPopup()}
      {RenderProviderStatusError()}
    </>
  );
};
export default ProviderStatus;
